"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxCredits = exports.ContactLink = exports.VATSelector = exports.PricingTotal = exports.PricingCalculationBox = exports.PricingCalculation = exports.CreditsExplanation = exports.MoreDetials = exports.Introduction = exports.FreeCreditFeatures = exports.FreeCredit = exports.ContactSales = exports.Block = exports.BoxBottom = exports.BoxTop = exports.SliderWrapper = exports.BoxChosen = exports.SmallTextBox = exports.AboveCredits = exports.CreditsIntroduction = exports.BoxHead = exports.Box = exports.ButtonFreeText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_components_1 = __importStar(require("styled-components"));
const polished_1 = require("polished");
const styled_breakpoints_1 = require("styled-breakpoints");
const elements_1 = require("@src/components/elements");
const get_product_pricing_1 = require("@src/shared/get-product-pricing");
const config_1 = __importDefault(require("@src/config"));
const types_1 = require("@src/types");
const account_context_1 = require("@src/context/account-context");
exports.ButtonFreeText = styled_components_1.default.div ``;
exports.Box = styled_components_1.default.div `
	width: 100%;
	min-height: 300px;
	position: relative;
	background: ${props => props.theme.color.brand1};
	color: ${props => props.theme.color.white};
	border-radius: 0 0 4px 4px;
	box-shadow: 0 15px 35px rgb(50 50 66 / 30%), 0 5px 15px rgb(0 0 0 / 7%);
	overflow: hidden;

	${(0, styled_breakpoints_1.up)('md')} {
		border-radius: 4px;
		width: 50%;
	}
`;
exports.BoxHead = styled_components_1.default.div `
	padding: 1.5em 3em 1.2em;
	text-align: center;
	background: ${props => (0, polished_1.transparentize)(0.7, props.theme.color.brand4)};

	font-weight: 400;
	font-size: 1.3em;
	color: ${props => props.theme.color.white};

	strong {
		font-weight: 700;
		text-transform: uppercase;
		color: ${props => props.theme.color.gray2};
	}
`;
exports.CreditsIntroduction = styled_components_1.default.div `
	text-align: center;
	color: ${props => (0, polished_1.transparentize)(0.2, props.theme.color.white)};
	font-size: 1.2em;
	padding: 2em 3em 2em;

	small {
		color: ${props => (0, polished_1.transparentize)(0.4, props.theme.color.white)};
		font-size: 0.8em;
	}
`;
exports.AboveCredits = styled_components_1.default.div `
	text-align: center;
	color: ${props => (0, polished_1.transparentize)(0.4, props.theme.color.white)};
	font-weight: 700;
	padding: 0 3em 0.5em;
`;
exports.SmallTextBox = styled_components_1.default.div `
	text-align: center;
	color: ${props => (0, polished_1.transparentize)(0.1, props.theme.color.white)};
	font-size: 1em;
	padding: 0 2em 1em;

	small {
		color: ${props => (0, polished_1.transparentize)(0.4, props.theme.color.white)};
		font-size: 0.9em;
	}
`;
exports.BoxChosen = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.brand1};
	padding: 1rem 1rem 0.1rem;
	text-align: center;
	font-size: 2rem;
	font-weight: 700;

	${({ color }) => color === 'white' &&
    (0, styled_components_1.css) `
			color: ${({ theme }) => theme.color.white};
		`}
`;
exports.SliderWrapper = styled_components_1.default.div `
	padding: 1.1em 5em 1.5em;
	text-align: center;
`;
exports.BoxTop = styled_components_1.default.div ``;
exports.BoxBottom = styled_components_1.default.div ``;
exports.Block = styled_components_1.default.div `
	width: 100%;
`;
exports.ContactSales = styled_components_1.default.div `
	width: 100%;
	padding: 2em 3em 1.8em;
	text-align: center;
	color: ${props => (0, polished_1.transparentize)(0.3, props.theme.color.white)};
	background: ${props => (0, polished_1.transparentize)(0.85, props.theme.color.black)};
`;
exports.FreeCredit = styled_components_1.default.div `
	width: 100%;
	padding: 2em 0;
	text-align: center;
`;
exports.FreeCreditFeatures = styled_components_1.default.div `
	width: 100%;
	display: flex;
	flex-direction: column;
	padding: 2em 3em 1.5em;
	border-top: 1px solid ${props => props.theme.color.gray2};

	ul {
		width: 400px;
		max-width: 100%;
		margin: 0 auto;
		padding: 0 0 0 2.5em;
		color: ${props => props.theme.color.gray6};
		font-size: 1.2em;
	}
`;
exports.Introduction = styled_components_1.default.div `
	text-align: center;
	color: ${props => props.theme.color.gray6};
	font-size: 1.2em;
	padding: 2em 2em 0;
`;
exports.MoreDetials = styled_components_1.default.a `
	margin: 1.5em auto 0;
	display: inline-block;
	text-decoration: underline;
	color: ${props => props.theme.color.gray5};
	font-size: 0.9em;
`;
exports.CreditsExplanation = styled_components_1.default.div `
	margin: 1.5em auto 0;
	display: block;
	text-align: center;
	color: ${props => props.theme.color.gray5};
	font-size: 0.9em;
`;
exports.PricingCalculation = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	padding: 0;
`;
exports.PricingCalculationBox = styled_components_1.default.div `
	display: flex;
	width: 50%;
	justify-content: center;

	dl {
		margin: 0;
	}
	dt {
		color: ${props => (0, polished_1.transparentize)(0.5, props.theme.color.white)};
		font-size: 0.9em;
	}
	dd {
		color: ${props => props.theme.color.white};
		font-size: 2em;
	}
`;
exports.PricingTotal = styled_components_1.default.div `
	border-top: 1px solid ${props => (0, polished_1.transparentize)(0.85, props.theme.color.white)};
	padding: 1.5em 0 0;
	width: 100%;
	justify-content: center;
`;
exports.VATSelector = styled_components_1.default.div `
	text-align: center;
	color: ${props => (0, polished_1.transparentize)(0.5, props.theme.color.white)};
	font-size: 0.9em;
	padding: 2em 3em 2em;
	display: flex;
	justify-content: center;
	align-items: center;
	& > * + * {
		margin-left: 0.7em;
	}
`;
exports.ContactLink = (0, styled_components_1.default)(elements_1.Link) `
	display: block;
	margin: 0.5em auto 0;
	text-decoration: underline;
	&:link,
	&:visited,
	&:focus {
		color: ${props => props.theme.color.white};
	}
`;
const BoxCredits = () => {
    const theme = (0, styled_components_1.useTheme)();
    const [withVAT, setWithVAT] = react_1.default.useState(false);
    const [creditCount, setCreditCount] = react_1.default.useState(10);
    const [creditPricing, setCreditPricing] = react_1.default.useState(null);
    const account = (0, account_context_1.useAccount)();
    react_1.default.useEffect(() => {
        setCreditPricing((0, get_product_pricing_1.getProductPricing)({ productCount: creditCount, productId: types_1.ProductId.offerCredits }));
    }, [creditCount]);
    const getCta = () => {
        return account ? `/admin/objednavka?product=${types_1.ProductId.offerCredits}&amount=${creditCount}` : '/registration';
    };
    return ((0, jsx_runtime_1.jsxs)(exports.Box, { children: [(0, jsx_runtime_1.jsx)(exports.BoxHead, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.credits.headline" }) }), (0, jsx_runtime_1.jsxs)(exports.CreditsIntroduction, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.credits.bulk_1" }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("small", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.credits.bulk_2" }) })] }), (0, jsx_runtime_1.jsx)(exports.AboveCredits, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.credits.want_order" }) }), (0, jsx_runtime_1.jsx)(exports.BoxChosen, { color: "white", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { values: { count: creditCount }, id: "general.credits.pluralized" }) }), (0, jsx_runtime_1.jsx)(exports.SliderWrapper, { children: (0, jsx_runtime_1.jsx)(elements_1.SliderCredits, { value: creditCount, onChange: value => setCreditCount(value), dark: true }) }), creditPricing && ((0, jsx_runtime_1.jsxs)(exports.Introduction, { children: [(0, jsx_runtime_1.jsxs)(exports.PricingCalculation, { children: [(0, jsx_runtime_1.jsx)(exports.PricingCalculationBox, { children: (0, jsx_runtime_1.jsxs)("dl", { children: [(0, jsx_runtime_1.jsx)("dt", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.credits.price_single" }) }), (0, jsx_runtime_1.jsx)("dd", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedNumber, { value: withVAT ? creditPricing.productPrice : creditPricing.productPriceWithoutVat, style: "currency", currency: "EUR" }) })] }) }), creditPricing.discountRelative > 0 && ((0, jsx_runtime_1.jsx)(exports.PricingCalculationBox, { children: (0, jsx_runtime_1.jsxs)("dl", { children: [(0, jsx_runtime_1.jsx)("dt", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.credits.your_discount" }) }), (0, jsx_runtime_1.jsxs)("dd", { children: ["~", (0, jsx_runtime_1.jsx)(react_intl_1.FormattedNumber, { value: creditPricing.discountRelative, style: "unit", unit: "percent" })] })] }) }))] }), (0, jsx_runtime_1.jsxs)(exports.PricingTotal, { children: [(0, jsx_runtime_1.jsxs)(exports.SmallTextBox, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.credits.total" }), ' ', (0, jsx_runtime_1.jsx)(react_intl_1.FormattedNumber, { value: withVAT ? creditPricing.totalPrice : creditPricing.totalPriceWithoutVat, style: "currency", currency: "EUR" }), creditPricing.discountRelative > 0 && ((0, jsx_runtime_1.jsxs)("small", { children: [(0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.credits.you_save" }), ' ', (0, jsx_runtime_1.jsx)(react_intl_1.FormattedNumber, { value: withVAT ? creditPricing.discount : creditPricing.discountWithoutVat, style: "currency", currency: "EUR" }), ' ', "(", (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.credits.price_without_discount" }), ' ', (0, jsx_runtime_1.jsx)(react_intl_1.FormattedNumber, { value: withVAT
                                                    ? creditPricing.originalPrice
                                                    : creditPricing.originalPriceWithoutVat, style: "currency", currency: "EUR" }), ")"] }))] }), (0, jsx_runtime_1.jsx)(elements_1.Button, { style: {
                                    background: theme.color.success,
                                    borderColor: theme.color.success,
                                    color: theme.color.white,
                                }, link: getCta(), children: (0, jsx_runtime_1.jsxs)(exports.ButtonFreeText, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.credits.order" }), ' ', (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { values: { count: creditCount }, id: "general.credits.pluralized" })] }) })] }), (0, jsx_runtime_1.jsxs)(exports.VATSelector, { children: [(0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.credits.show_prices_with_vat" }), ' ', (0, jsx_runtime_1.jsx)(react_intl_1.FormattedNumber, { value: config_1.default.pricing.VAT, style: "unit", unit: "percent" })] }), (0, jsx_runtime_1.jsx)(elements_1.Switch, { checked: withVAT, onChange: checked => setWithVAT(checked) })] })] })), (0, jsx_runtime_1.jsxs)(exports.ContactSales, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.credits.want_more" }), (0, jsx_runtime_1.jsx)(exports.ContactLink, { to: "/kontakt", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "companies.credits.contact_us" }) })] })] }));
};
exports.BoxCredits = BoxCredits;
